var __gh__adsLoaded		= false;

/*
|--------------------------------------------------------------------------
| Template Slots and Maps: DFP
|--------------------------------------------------------------------------
*/
/**
 * @namespace --
 */

var dfpAdUnitMap = {
	"template": {
		"homepage": {
			"adunit": "homepage"
		},
		"sectionStandard": {
			"adunit": "news"
		},
		"article": {
			"adunit": "news"
		}
	}
}

var dfpMaps = {
	"map": {
		"baseLeaderBillboard": {
			"view1": {
					"viewport": [970,200],
					"ad_sizes": [[728,90],[970,90],[970,250]]
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": [[300,250],[320,50]]
				}
		},
		"baseLeaderboard": {
			"view1": {
					"viewport": [970,200],
					"ad_sizes": [[728,90],[970,90]]
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": [320,50]
				}
		},
		"baseLeaderboardNoSuper": {
			"view1": {
					"viewport": [970,200],
					"ad_sizes": [728,90]
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": [320,50]
				}
		},
		"baseMedRecDesktop": {
			"view1": {
					"viewport": [992,200],
					"ad_sizes": [300,250]
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": []
				}
		},
		"baseMedRecMobile": {
			"view1": {
					"viewport": [992,200],
					"ad_sizes": []
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": [300,250]
				}
		},
		"promoDesktop": {
			"view1": {
					"viewport": [992,200],
					"ad_sizes": [320,250]
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": []
				}
		}
	}
}

var homepageSlots ={
	"base": {
		"type": "homepage",
		"keyvalues": {
			"pgtype": "homepage",
			"platform": "web",
			"user-type": "Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments",
			"pos": "atf"
		},

		"slots": {
			"standard": {
				"baseMedRecDesktop": {
				"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec"
					}
				},
				"baseMedRecMobile": {
				"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec"
					}
				},
				"baseLeaderBillboard": {
					"id": "2",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 250
						}
					}, {
						"id": 2,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 3,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard"
					}
				}
			},
			"rich media": {
				"slidingBillboard": {
					"id": "3",
				    "dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "sbillboard",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Sliding Billboard"
					}
				},

				"wallpaper": {
					"id": "4",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "wallpaper",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Wallpaper"
					}
				}
			}
		}
	}
}

var sectionStandardSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "section",
			"platform": "web",
			"user-type": "Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments",
			"pos": "atf"
		},

		"slots": {
			"standard": {
				"baseMedRec": {
				"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec"
					}
				},
				"baseLeaderBillboard": {
					"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 250
						}
					}, {
						"id": 2,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 3,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard"
					}
				}
			},
			"rich media": {
				"slidingBillboard": {
					"id": "2",
				    "dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "sbillboard",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Sliding Billboard"
					}
				},

				"wallpaper": {
					"id": "3",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "wallpaper",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Wallpaper"
					}
				},

				"interstitial": {
					"id": "4",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "interstitial",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Interstitial"
					}
				}
			}
		}
	}
}

var articleSlots ={
	"base": {
		"type": "article",
		"keyvalues": {
			"pgtype": "article",
			"platform": "web",
			"user-type": "Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments",
			"pos": "atf"
		},

		"slots": {
			"standard": {
				"baseMedRec": {
				"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec"
					}
				},
				"baseLeaderboard": {
					"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard"
					}
				}
			},
			"rich media": {
				"interstitial": {
					"id": "2",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "interstitial",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Interstitial"
					}
				}
			}
		}
	}
}

var verticalSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "section",
			"platform": "web",
			"user-type": "Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments",
			"pos": "atf"
		},

		"slots": {
			"standard": {
				"baseMedRec": {
				"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec"
					}
				},
				"baseLeaderboard": {
					"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard"
					}
				}
			},
		}
	}
}

var sectionPhotoSlots ={
	"base": {
		"type": "photogallery",
		"keyvalues": {
			"pgtype": "photogallery",
			"platform": "web",
			"user-type": "Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments",
			"pos": "atf"
		},

		"slots": {
			"standard": {
				/*"baseMedRec": {
				"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec"
					}
				},*/
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard"
					}
				}
			},
		}
	}
}

var sectionVideoSlots ={
	"base": {
		"type": "video",
		"keyvalues": {
			"pgtype": "video",
			"platform": "web",
			"user-type": "Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments",
			"pos": "atf"
		},

		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard"
					}
				}
			},
		}
	}
}

var wrapperSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "wrapper",
			"platform": "web",
			"user-type": "Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments",
			"pos": "atf"
		},

		"slots": {
			"standard": {
				"baseMedRec": {
				"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec"
					}
				},
				"baseLeaderboard": {
					"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard"
					}
				}
			}
		}
	}
}

var searchSlots = {
	"base": {
		"type": "SiteSearch",
		"keyvalues": {
			"pgtype": "SiteSearch",
			"platform": "web",
			"user-type": "Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments",
			"pos": "atf"
		},

		"slots": {
			"standard": {
				"baseMedRec": {
				"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec"
					}
				},
				"baseLeaderboard": {
					"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard"
					}
				}
			}
		}
	}
}

var legacyHeaderSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "section",
			"platform": "web",
			"user-type": "Unknown",
			"keyword": "obituaries",
			"referrer-type": "",
			"kuid": "~Krux.user",
			"pos": "atf"
		},

		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 928,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"BaseLeaderboard"
					}
				}
			}
		}
	}
}

var headerOnlySlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "section",
			"platform": "web",
			"user-type": "Unknown",
			"referrer-type": "",
			"kuid": "~Krux.user",
			"pos": "atf"
		},

		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 928,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"BaseLeaderboard"
					}
				}
			}
		}
	}
}

var tmplDefinitionsJSON = {
	"template": {
		"homepage": {
			"slotFeed": homepageSlots
		},
		"sectionStandard": {
			"slotFeed": sectionStandardSlots
		},
		"vertical": {
			"slotFeed": verticalSlots
		},
		"article": {
			"slotFeed": articleSlots
		},
		"sectionVideo": {
			"slotFeed": sectionVideoSlots
		},
		"sectionPhoto": {
			"slotFeed": sectionPhotoSlots
		},
		"wrapper": {
			"slotFeed": wrapperSlots
		},
		"search": {
			"slotFeed": searchSlots
		},
		"legacyHeader": {
			"slotFeed": legacyHeaderSlots
		},
		"headerOnly": {
			"slotFeed": headerOnlySlots
		}
	}
}

